module.exports = __webpack_public_path__ + "img/settings.b1fee017.svg";